import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import { selectAllCatalogItems, getCatalog, catalogTotalCount, searchCatalog } from '../../reducers/catalog';
import Product from "./Product";
import PrintItemCard from "../PrintItemCard";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import ProductMenu from '../ProductMenu';
import { selectAllMenuItems } from '../../reducers/menu';
import MSMPagination from '../MSMPagination';
import { Container, Row, Badge, Button } from "react-bootstrap";
import { getSubsite } from '../../reducers/auth';
import { XCircle } from 'react-bootstrap-icons';
import PrintItemService from '../../services/printitem.service';

const AdminCatalog = () => {
  let { categoryId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const catalog = useSelector(selectAllCatalogItems);
  const menu = useSelector(selectAllMenuItems);
  const featured = useSelector(state => state.featured);

  const [resetPagination, setResetPagination] = useState(false);
  const [range, setRange] = useState([1, 12]);

  const catalogStatus = useSelector(state => state.catalog.status)
  const catalogTotal = useSelector(catalogTotalCount);
  const currentSubsite = useSelector(getSubsite);

  const searchTerm = searchParams.get("searchTerm");

  // Print category detection: use originalCategoryName because subsites may rename via override
  const menuList = Array.isArray(menu) ? menu : (menu?.menu || []);
  const isPrintCategory = !!menuList.find(
    m => String(m.id) === String(categoryId) &&
         (m.originalCategoryName === 'Print' || m.categoryName === 'Print')
  );

  const [printItems, setPrintItems] = useState([]);
  const [printLoading, setPrintLoading] = useState(false);

  const loadPrintItems = async () => {
    setPrintLoading(true);
    try {
      const items = await PrintItemService.getSubsitePrintItemCatalog();
      setPrintItems(items || []);
    } catch (e) {
      console.error("Failed to load print items for admin catalog", e);
      setPrintItems([]);
    } finally {
      setPrintLoading(false);
    }
  };

  const clearSearch = () => {
    navigate(`/admin/catalog/${categoryId || 1}`);
  };

  useEffect(() => {
    if (isPrintCategory) {
      loadPrintItems();
      return;
    }
    if (catalogStatus === 'idle') {
      if (categoryId === 0) {
        categoryId = menu.menu[0].id;
      }
      dispatch(getCatalog([categoryId, range[0], range[1]]));
    }
  }, [catalogStatus, dispatch, isPrintCategory]);

  useEffect(() => {
    if (isPrintCategory) {
      loadPrintItems();
      return;
    }
    dispatch(getCatalog([categoryId, range[0], range[1]]));
  }, [categoryId, dispatch, isPrintCategory]);

  useEffect(() => {
    if (isPrintCategory) return;
    if (searchParams.get("searchTerm")) {
      dispatch(searchCatalog([searchParams.get("searchTerm"), range[0], range[1]]));
    } else {
      dispatch(getCatalog([categoryId, range[0], range[1]]));
    }
  }, [range, searchParams, dispatch, isPrintCategory]);

  const reloadData = (range) => {
    setRange(range);
  }

  return (
    <div className="container">
      <ProductMenu url="/admin/catalog/" menuBgColor={currentSubsite.subsite_content?.menuBgColor} menuTextHoverColor={currentSubsite.subsite_content?.menuTextHoverColor} menuTextColor={currentSubsite.subsite_content?.menuTextColor}/>

      {searchTerm && (
        <div style={{ marginBottom: 10, padding: 10, backgroundColor: '#f8f9fa', borderRadius: 5 }}>
          <span>Search results for: <strong>"{searchTerm}"</strong></span>
          <Button variant="link" size="sm" onClick={clearSearch} style={{ marginLeft: 10 }}>
            <XCircle /> Clear Search
          </Button>
        </div>
      )}

      {!isPrintCategory && (
        <MSMPagination reload={reloadData} perPage={range[1]} total={catalogTotal} reset={resetPagination} />
      )}
      {!isPrintCategory && catalogStatus === 'loading' && <Spinner text="Loading..." />}
      {!isPrintCategory && catalogStatus === 'error' && <div>Error Loading Products</div>}
      {isPrintCategory && printLoading && <Spinner text="Loading..." />}
      <Container>
        <Row>
          {!isPrintCategory && catalog && catalog.catalog && catalog.catalog.map(catalogItem => (
            <Product key={`prod_${catalogItem.id}`} product={catalogItem} />
          ))}
          {isPrintCategory && !printLoading && printItems.length === 0 && (
            <div className="text-muted p-3">No print items in this subsite's catalog.</div>
          )}
          {isPrintCategory && printItems.map(item => (
            <PrintItemCard key={`printitem_${item.id}`} item={item} adminMode />
          ))}
        </Row>
      </Container>
    </div>
  );
};
export default AdminCatalog;